import filter from 'lodash/filter';

import constants from '@/constants';

export default {
  methods: {
    filterDeletedOvertimeSegments(segments) {
      return filter(segments,
        (segment) => !(this.isOvertimeRelatedSegment(segment) && segment.deletedDate != null));
    },

    isOvertimeRelatedSegment(segment) {
      return segment.pairType === constants.WorkSchedule.SegmentType.OT_BREAK
      || segment.pairType === constants.WorkSchedule.SegmentType.OVERTIME
      || segment.pairType === constants.WorkSchedule.SegmentType.FIXED_OVERTIME
      || segment.pairType === constants.WorkSchedule.SegmentType.PRE_SHIFT_OT
      || segment.pairType === constants.WorkSchedule.SegmentType.EARLY_LOGIN;
    },
  },
};
